module.exports = __webpack_public_path__ + "img/image-thumb-19.f33feb87.jpg";